<template>
  <div>
    <v-row v-if="settings.actionsPanel">
      <v-col class="pl-1 pr-1 ml-5" v-show="checkedRows.length > 0" id="actions-panel">
        <ActionsPanel 
          @on-delete="onDeleteSelectedRows"
          @on-hide-deselected="onHideDeselected"
          @on-export="onExport"
          :key="actionKey"/>  
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <table v-if="getWindowWidth > breakpoint">
            <thead>
                <Draggable :list="columns" tag="tr" draggable=".canDrag">
                  <th class="checkbox" slot="header" v-bind:class="{'hide': !settings.actionsPanel && !settings.singleSelect }">
                    <div v-if="settings.actionsPanel">
                      <img :src="checkedAll?uncheckAll:uncheckedIcon" @click="checkAll" v-model="checkedAll"/>
                    </div>
                  </th>
                  <th v-for="(col, index) in columns" :key="index" :width="col.width?col.width:''" @click="sort(col, index)" :title="col.name" class="canDrag">
                    {{ col.name }}
                    <v-icon v-if="settings.sorting" class="sort-icon" v-text="col.order != undefined? col.order? 'mdi-menu-up' : 'mdi-menu-down' : 'mdi-menu-swap' "></v-icon>
                  </th>
                  <th v-if="settings.moreActions" class="more-actions">
                    <img :src="combinedShapeIcon" />
                  </th>
                </Draggable>
            </thead>
            <!-- the only way I found to pass a dynamic class and have it scoped in the data-table component. 
            The class is declared in data-table but bind from the parent component as prop -->
            <tbody ref="tbody" v-bind:class="{ 'withActions': checkedRows.length > 0 , [customTbodyClass]: customTbodyClass}">
              <tr v-if="rows.length === 0">
                <td class="text-center">
                  {{ $t('table-no-rows') }}
                </td>
              </tr>
                <tr v-for="(row, indexRow) in rows" :key="indexRow" :class="row.hide ? 'hide': ''"  >
                 <td class="checkbox" v-bind:class="{'hide': !settings.actionsPanel && !settings.singleSelect }">
                    <div v-if="settings.actionsPanel  || settings.singleSelect" :class="row.checked ? 'checked': ''">
                      <img :src="(row.checked)?checkedMarkIcon:uncheckedIcon" @click="checkRow(row)" v-model="row.checked"/>
                    </div>
                  </td> 
                  <td v-bind:class="{'border-highlighted': colIndex === 0 && !settings.actionsPanel && !settings.singleSelect, 'capitalize': col.capitalizeStyle }" v-for="(col, colIndex) in columns" :key="colIndex" :width="col.width?col.width:''">
                      <!-- get the data from single value, example data = name -->
                      <template v-if="col.type === 'data'"> {{ row[col.field] }}</template>
                      <!-- get the data value from object, exmaple data = user.name -->
                      <template v-if="col.type === 'objectData'"> {{ getValueFromStringObjectProperty(row, col.field) }}</template>
                      <!-- render a component -->
                      <template v-else-if="col.type === 'render' || col.type === 'renderObject'">
                        <component 
                          :params="row"
                          :renderParams="col.renderParams ? col.renderParams : null"
                          :field="(col.type === 'renderObject') ? addObjectEntry(row, col.field) : col.field"
                          :is="col.cellRenderer"                      
                          @previewItem="previewItem"
                            >
                        </component>
                      </template>
                      <template v-else-if="col.type === 'date'"><span v-if="row[col.field]">{{ row[col.field] | moment(col.format) }}</span></template>
                      <template v-else-if="col.type === 'bool'"> {{ row[col.field] ? $t('yes') : $t('no') }} </template>
                  </td>
                  <td v-if="settings.moreActions" class="more-actions">
                    <ActionsPopupComponent :actions="settings.moreActions" :row="row"/>
                  </td>
                </tr>
            </tbody>
        </table>
        <table id="mobileTable" v-if="getWindowWidth <= breakpoint">
          <tbody v-bind:class="{ [customTbodyClass]: customTbodyClass, 'iPlus': getWindowWidth <= iPlus }">
            <tr v-for="(row, indexR) in rows" :key="indexR" class="v-data-table__mobile-table-row">
              <td v-for="(col, indexC) in columns" :key="indexC" class="v-data-table__mobile-row" v-bind:class="{ 'hide': !row[col.field]}">
                <v-row>
                  <v-col v-if="settings.moreActions && indexC === 0" cols="12" class="py-0 mb-1 text-right">
                    <span v-for="(action, index) in settings.moreActions" :key="index">
                      <v-icon v-if="action.enabledIf ? isEnabled(action.enabledIf, row) ? true : false : true" @click="action.fn(row)" class="ml-2" small color="secondary">mdi-{{action.icon}}</v-icon>
                    </span>
                  </v-col>
                  <v-col cols="4"  class="py-0">
                    {{ col.name }}
                  </v-col>
                  <v-col cols="8" class="text-right py-0">
                    <!-- get the data from single value, example data = name -->
                    <template v-if="col.type === 'data'"> {{ row[col.field] }}</template>
                    <!-- get the data value from object, exmaple data = user.name -->
                    <template v-if="col.type === 'objectData'"> {{ getValueFromStringObjectProperty(row, col.field) }}</template>
                    <!-- render a component -->
                    <template v-else-if="col.type === 'render' || col.type === 'renderObject'">
                      <component 
                        :params="row"
                        :renderParams="col.renderParams ? col.renderParams : null"
                        :field="(col.type === 'renderObject') ? addObjectEntry(row, col.field) : col.field"
                        :is="col.cellRenderer"                      
                        @previewItem="previewItem"
                          >
                      </component>
                    </template>
                    <template v-else-if="col.type === 'date'"><span v-if="row[col.field]">{{ row[col.field] | moment(col.format) }}</span></template>
                    <template v-else-if="col.type === 'bool'"> {{ row[col.field] ? $t('yes') : $t('no') }} </template>
                  </v-col>
                </v-row>
              </td>
            </tr>
          </tbody>
        </table>
      <confirm-modal
      @confirm="confirmDelete"
      @cancel="confirmationDeleteSelectionDialog = false"
      :dialogModel="confirmationDeleteSelectionDialog"
      :dialogBody="($t(confirmDeleteModalBody) || $t('delete-selection-default')) + ' ('+assetsNumberToDelete+')'"
      :dialogTitle="$t(confirmDeleteModalTitle) || $t('delete-selection-title-default')"/>   
      </v-col>
    </v-row>  
    <v-row>
      <Pagination v-bind:class="{'mobile mt-6': getWindowWidth <= breakpoint}" v-if="totalRows > 0 && !settings.noPagination" :rowsCount="rowsCount" :page="page" :size="pageSize" @paginationChange="paginationChange" />
    </v-row>
  </div>
</template>

<script>
  import { mapMutations, mapGetters } from 'vuex'
  import ActionsPopupComponent from "./custom-cells/actions-popup"
  import ActionsPanel from "./utilities/actions-panel"
  import Pagination from "./utilities/pagination.vue"
  import Draggable from 'vuedraggable'
  import ConfirmModal from '../modals/confirmModal'
  import constants from '../../../constants/resolutions-constants'

  export default {
    components: {
      ActionsPopupComponent,
      ActionsPanel,
      Pagination,
      ConfirmModal,
      Draggable
    },
    data() {
      return {
        uncheckedIcon: require("../../../assets/img/icons/unchecked.svg"),
        checkedMarkIcon: require("../../../assets/img/icons/white-check.png"),
        uncheckAll: require("../../../assets/img/icons/checkbox-deselect.svg"),
        combinedShapeIcon: require("../../../assets/img/icons/combined-shape.svg"),
        checkedAll: false,
        checkedRows: [],
        sortBy: null,
        sortedColIndex: -1,
        sortDirection: "",
        confirmationDeleteSelectionDialog: false,
        assetsNumberToDelete: 0,
        actionKey: true,
        breakpoint: constants.IPAD_PORTRAIT,
        iPlus: constants.IPHONE_8_PLUS
      }
    }, 
    props: [
      'settings',
      'columns',
      'customTbodyClass',
      'rows',
      'page',
      'pageSize',
      'maxHeight',
      'totalRows',
      'confirmDeleteModalTitle',
      'confirmDeleteModalBody'
    ],
    watch: {
      rows() {
        if(this.rows.filter((row) => row.checked === true).length === 0){
          this.checkedRows = [];
          this.checkedAll = false;
          this.actionKey = !this.actionKey;
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        //after tbody element is rendered we can modify its mx height
        if (this.maxHeight && this.$refs.tbody) {
          this.$refs.tbody.style.maxHeight = this.maxHeight;
        }
      })
      if(this.settings.actionsPanel || this.settings.singleSelect){
        this.rows.forEach(row => {
          this.$set(row, 'checked', false);
          this.$set(row, 'hide', false);
        });
      }
    },
    methods: {
      ...mapMutations('layout', ['setRightContainerComponent']),
      previewItem(item) {
        this.setRightContainerComponent({comp: this.settings.rowPreview, item: item});
      },
      checkAll(){
        this.checkedAll = !this.checkedAll;
        this.rows.forEach(row => {
          row.checked = this.checkedAll;
        });
        if(this.checkedAll){
          this.checkedRows = this.rows;
        }else{
          this.checkedRows = [];
        }
      },
      selectRow(row){
        row.checked = !row.checked;
        if(this.checkedRows && this.checkedRows.id !== row.id){
          this.checkedRows.checked = !this.checkedRows.checked;
        }
        this.checkedRows = row.checked ? row : [];
        this.$emit('onRowSelected', row.checked ? row : null);
      },
      checkRow(row){
        if(this.settings.singleSelect){
          this.selectRow(row);
        }else{
          row.checked = !row.checked;
          this.checkedAll = false;
          this.checkedRows = this.rows.filter( row => {
            return row.checked === true;
          });
        }
      },
      onHideDeselected(hide){
        if (hide) {
          this.rows.filter( row => {
            if (!row.checked)
              this.$set(row, 'hide', true);
          }); 
        }
        else {
          this.rows.filter( row => {
            if (row.hide)
              this.$set(row, 'hide', false);
          }); 
        }
      },
      onExport() {
        this.$emit('onExport', this.checkedRows)
      },
      onDeleteSelectedRows() {
        this.assetsNumberToDelete = this.checkedRows.length;        
        this.confirmationDeleteSelectionDialog = true; 
      },
      confirmDelete() {
        this.confirmationDeleteSelectionDialog = false; 
        this.$emit('onDeleteSelection', this.checkedRows);
      },
      //returns the value of a string object property
      getValueFromStringObjectProperty(obj, field) {
        let values = field.split('.');
        let aux = {}; 
        for (let index = 0; index < values.length; index++) { 
          const property = values[index];
          if (index === 0) {
            aux = obj[property];
          }else {
            aux = aux[property];
          }
        }        
        return aux;
      },
      addObjectEntry(obj, field){
        obj[field] = this.getValueFromStringObjectProperty(obj, field);
        return field;
      },
      sort(col, index) {
        if(this.settings.sorting){
          if (!col.order) {
            this.$set(col, "order", true);
          } else {
              this.$set(col, "order", !col.order);
            }

          if (this.sortedColIndex != -1 && this.sortedColIndex != index) {
            this.columns[this.sortedColIndex].order = undefined;
          }
          this.sortedColIndex = index;
          this.sortDirection = col.order ? "asc" : "dsc";
          this.sortBy = col.field;
          this.$emit('onSort', '&sortBy='+this.sortBy+'&sort='+this.sortDirection)
        }
      },
      paginationChange(pagination){
        this.$emit('onPaginationChange', { 'page': pagination.page, 'pageSize': pagination.size });
      },
      isEnabled(fields, row){
        let enable = true;
        fields.forEach( f => {
          if(!row[f]){
            enable = false;
          }
        });
        return enable;
      }
    },
    computed:{
      ...mapGetters('layout', ['getWindowWidth']),
      rowsCount() {
        return this.totalRows;
      }
    }  
}
  
</script>

<style lang="scss" scoped>
  table {
    width: 100%;
    border-collapse: collapse;
    thead {
      width: calc( 100% - 1rem );
      :nth-child(2) { // apply padding to the name column header text in order to align after icon in cells
        padding-left: 35px;
      }
      :nth-child(8){ 
        text-align:center;
        padding-left:0px;
      }
      th{
       text-align: left;
       height: 51px!important;
       border: 1px solid #7C8D95;
       background-color: #3B5762;
       color:white;
       font-size: 0.75rem;
       text-transform: uppercase;
       padding-left: 12px;
      cursor:pointer;

      }
    }
    th, td {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &.more-actions{
        text-align: center;
        width: 100px;
       }
      &.capitalize{
        text-transform: capitalize;
      }
    }
  }

  thead,
  tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    height: 51px;
  }

  table tbody{
    display: block;
    overflow: scroll;
    height: calc(100vh - 276px);
    min-height: calc(100vh - 650px);
    &.withActions{
     height: calc(100vh - 333px);
    }
    &.withoutFilters{
      height: calc(100vh - 338px);
    }
    &.withActions.withoutFilters{
     height: calc(100vh - 395px);
    }
    &.withFilters{
     height: calc(100vh - 380px);
    }
    &.withActions.withFilters{
     height: calc(100vh - 437px);
    }
    tr {
      border-bottom: 1px solid #d9dcde; 
      border-collapse: collapse;
      &:nth-child(2n){
        background-color:#F8F8F9;
      }
      &:hover td {
        background-color: #e1e2e4;
        &:nth-child(1):not(.hide){
           box-shadow: inset 5px 0 var(--v-secondary-base);
        }
        &.border-highlighted{
           box-shadow: inset 5px 0 var(--v-secondary-base);
        }
      }
    }
    td{
        font-size: .8rem;
        font-weight: 600;
        color: var(--v-primary-darken2);
        padding: 5px 11px 0px;
        min-width:50px;
      }
  }
  table#mobileTable{
    tbody.withFilters{
      height: calc(100vh - 324px);
      @media (max-width: 600px){
        height: calc(100vh - 271px);
      }
    }
    tbody.withoutFilters{
      height: calc(100vh - 271px);
    }
    tbody.iPlus{
      height: calc(100vh - 271px);
    }
    tr{
      &:first-child{
        border-top: 1px solid #d9dcde;
      }
      &:hover td{
        box-shadow: inset 5px 0 var(--v-secondary-base);
      }
      td:last-child{
        padding-bottom: 5px;
      }
    }
  }
  #pagination.mobile {
    margin: 0 -9px;
  }
  .hide{
    display:none;
  }
  th.checkbox{ padding-left: 10px;}
  th.checkbox, 
  td.checkbox{
    width: 43px;
    div{
      height: 20px;
      width: 20px;
      border-radius: 2px;
      margin-bottom: 7px;
      &.checked{
        background-color: var(--v-primary-base);
        margin-bottom: 0px;
        margin-left: 3px;
      }
      img{
        margin-left: 3px;
        margin-top: 4px;
      }
    }
  }

  /* end scrollbar */
  .sort-icon{
    color: #b8bdc7;
    width: 7px;
    margin-left: 10px;
    height: 10px;
    font-size: 18px;
  }
  
  // custom tbody classes
  .import-devices-modal {
    max-height: 250px;
    &.withActions{
     max-height: 250px;
    }
  }
  .tooltip{
    height: 29px;
    border-radius: 3px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
    background-color: var(--v-primary-base);
  }
  .users-page {
    height: calc(100vh - 235px) !important;
    &.withActions{
     max-height: calc(100vh - 290px);
    }
  }

</style>